<div class="gift-recipient-title" *ngIf="!isSenderTracking">
  <div class="customer-name">{{ 'Hello ' + pickupCustomerName + ',' }}</div>
  <ng-container [ngSwitch]="customerTrackingStatus">
    <div class="title" *ngSwitchCase="StatusEnum.Ordered">
      {{
        isDelayed
          ? 'Your gift' + (senderName ? ' from ' + senderName : '') + ' is delayed'
          : 'a gift' + (senderName ? ' from ' + senderName : '') + ' will be delivered to you today'
      }}
    </div>
    <div class="title" *ngSwitchCase="StatusEnum.OnItsWay">
      {{ 'Your gift' + (senderName ? ' from ' + senderName : '') + '  is on its way' }}
    </div>
    <div class="title" *ngSwitchCase="StatusEnum.OnItsWay">
      {{ 'Your gift' + (senderName ? ' from ' + senderName : '') + '  is at an access point' }}
    </div>
    <div class="title" *ngSwitchCase="StatusEnum.Delivered">
      {{ 'Your gift from ' + senderName + '  was delivered' }}
    </div>
  </ng-container>
  <common-gift-colored-icon
    class="gift-icon"
    [orderStatus]="customerTrackingStatus"
    [baseColor]="backgroundColor"></common-gift-colored-icon>
</div>
<div class="gift-sender-title" *ngIf="isSenderTracking && !isDelayed">
  <div class="customer-name">{{ 'Hello ' + (senderName || '') + ',' }}</div>
  <div>
    {{ 'Track the gift you’re sending to ' }}<b>{{ pickupCustomerName }}</b
    >{{ ' from ' }}<b>{{ merchantName }}</b>
  </div>
</div>
<div class="gift-sender-title" *ngIf="isSenderTracking && isDelayed">
  <div class="customer-name">{{ 'Hello ' + (senderName || '') + ',' }}</div>
  <div>
    {{ 'The gift you are sending to ' }}<b>{{ pickupCustomerName }}</b
    >{{ ' from ' }}<b>{{ merchantName }}</b
    >{{ ' is delayed' }}
  </div>
</div>
